import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../firebase/firebase';

class UserService {
  _storeOverride = null;

  setStoreOverride(storeId) {
    this._storeOverride = storeId;
  }

  clearStoreOverride() {
    this._storeOverride = null;
  }

  async getUserData(uid) {
    if (!uid) {
      throw new Error('User ID is required');
    }
    const userRef = doc(db, 'users', uid);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) {
      throw new Error('User document not found');
    }
    return userSnap.data();
  }

  async getUserStoreId() {
    // Return override if set (Dev/Owner switching stores)
    if (this._storeOverride) {
      return this._storeOverride;
    }

    // Default: fetch from Firestore
    const user = auth.currentUser;
    if (!user) throw new Error('User not logged in');

    const userRef = doc(db, 'users', user.uid);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) throw new Error('User document not found');

    return userSnap.data().store_id;
  }

  async getCurrentUserId() {
    const user = auth.currentUser;
    if (!user) throw new Error('User not logged in');
    return user.uid;
  }
}

const userService = new UserService();
export default userService;
